export default "__VITE_ASSET__C0FqfQsZ__ 720w";